import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import building from '../img/building.jpg';
import Login from './LoginDos';
import Logout from './Logout';
import videosrc from '../img/cyd_video_3.mp4';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles2 = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  center: {
    textAlign: 'center'
  },
  image: {
    backgroundImage: `url(${building})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  button: {
    margin: 10
  },
  paper: {
    margin: theme.spacing(4, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  google: {
    backgroundColor: 'green'
  },
  avatar: {
    width: 80,
    height: 80
  },
  leftGrid: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      flexGrow: 1
    }
  },
  rightGrid: {
    zIndex: 1,
    width: '100%',
    backgroundColor: 'white',
    [theme.breakpoints.up('md')]: {
      maxWidth: 580
    }
  }
}));

const style = {
  google: {
    width: '100%'
  }
};

export default function SignInSide(props) {
  const classes2 = useStyles2();
  const {
    handleLogout,
    loading,
    handleOnSubmit,
    handleChange,
    form,
    usuarioAutenticado,
    handleRedirect,
    handleGoogleLogin,
    handleMicrosoftLogin,
    handleBack
  } = props;

  const matches = useMediaQuery('(min-width:600px)');
  console.log(matches);

  return (
    <Grid container component="main" className={classes2.root}>
      <CssBaseline />
      <Grid item md className={classes2.leftGrid}>
        <video
          autoPlay
          loop
          muted
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block'
          }}>
          <source src={videosrc} type="video/mp4" />
        </video>
        <div
          style={{
            position: 'fixed',
            right: 0,
            bottom: 0,
            minWidth: '100vw',
            minHeight: '100vh',
            background: '#ffffff80'
          }}></div>
      </Grid>
      <Grid item md className={classes2.rightGrid}>
        {props.usuarioAutenticado ? (
          <Logout
            handleLogout={handleLogout}
            usuarioAutenticado={usuarioAutenticado}
            handleRedirect={handleRedirect}></Logout>
        ) : (
          <Login
            loading={loading}
            handleOnSubmit={handleOnSubmit}
            handleChange={handleChange}
            form={form}
            classes={classes2}
            handleGoogleLogin={handleGoogleLogin}
            handleMicrosoftLogin={handleMicrosoftLogin}
            handleBack={handleBack}
            style={{ width: '100%' }}></Login>
        )}
      </Grid>

      {/* <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        {props.usuarioAutenticado ? (
          <Logout
            handleLogout={handleLogout}
            usuarioAutenticado={usuarioAutenticado}
            handleRedirect={handleRedirect}
            classes={classes2}
          ></Logout>
        ) : (
          <Login
            handleSubmit={handleSubmit}
            handleChange={handleChange}
            form={form}
            classes={classes2}
            handleGoogleLogin={handleGoogleLogin}
            handleBack={handleBack}
          ></Login>
        )}
      </Grid> */}
    </Grid>
  );
}
